<template>
  <div class="UsuariosListado">
    <div v-if="isOnline">
      <md-table
        v-model="filtroUsr"
        md-sort="nombre_usr"
        md-sort-order="asc"
        md-fixed-header
        md-card
      >
        <md-table-toolbar>
          <div class="md-toolbar-section-start md-title">Usuarios registrados</div>
          <div class="md-toolbar-section-end">
            <md-field md-clearable>
              <md-input
                placeholder="Buscar..."
                v-model="buscar"
              />
            </md-field>
            <md-button
              class="md-icon-button"
              to="/usuario"
            >
              <md-icon>add</md-icon>
            </md-button>
          </div>
        </md-table-toolbar>
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          class="upper"
        >
          <md-table-cell
            md-label="Nombre"
            md-sort-by="nombre_usr"
          >
            {{item.nombre_usr + ' '+item.ap_pat_usr + ' '+item.ap_mat_usr}}
          </md-table-cell>
          <md-table-cell
            md-label="Jurisdicción"
            md-sort-by="nombre_ces"
          >
            {{item.nombre_ces}}
          </md-table-cell>
          <md-table-cell
            md-label="Tipo"
            md-sort-by="tipo_usr"
          >
            {{item.tipo_usr}}
          </md-table-cell>
          <md-table-cell
            md-label="Usuario"
            md-sort-by="usuario_usr"
          >
            {{item.usuario_usr}}
          </md-table-cell>
          <md-table-cell
            md-label="Estatus"
            md-sort-by="estatus_usr"
          >
            {{item.estatus_usr}}
          </md-table-cell>
          <md-table-cell md-numeric>
            <md-button
              class="md-icon-button md-dense"
              :to="`/usuario/${item.id}`"
            >
              <md-icon>edit</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>

      <Loading v-if="cargando" />
    </div>
    <InternetRequired v-else />
  </div>
</template>
<script>
const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarUsr = (items, term) => {
  if (term) {
    return items.filter(
      item =>
        toLower(item.nombre_usr).includes(toLower(term)) ||
        toLower(item.ap_pat_usr).includes(toLower(term)) ||
        toLower(item.ap_mat_usr).includes(toLower(term)) ||
        toLower(item.tipo_usr).includes(toLower(term)) ||
        toLower(item.usuario_usr).includes(toLower(term)) ||
        toLower(item.estatus_usr).includes(toLower(term))
    );
  }
  return items;
};

import InternetRequired from "@/components/InternetRequired";
import Loading from "@/components/Loading";
import falloResponse from "@/mixins/falloResponse.js";
import usuariosObtener from "@/mixins/usuariosObtener.js";
export default {
  name: "UsuariosListado",
  components: { Loading, InternetRequired },
  mixins: [falloResponse, usuariosObtener],
  methods: {
    buscarEnLaTabla() {
      this.filtroUsr = buscarUsr(this.usuarios, this.buscar);
    }
  },
  data() {
    return {
      buscar: null,
      filtroUsr: [],
      usuarios: [],
      cargando: false
    };
  },
  watch: {
    usuarios() {
      this.filtroUsr = this.usuarios;
    },
    buscar(a) {
      this.buscarEnLaTabla();
    }
  },
  created() {
    this._obtenerUsuarios();
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  },
  computed: {
    networkStatus() {
      let a = this.isOnline ? true : false;
      return a;
    }
  }
};
</script>